/**
 * Shared key + helper for suppressing the exit-intent modal across the site.
 *
 * Any conversion event (estimate form submit, Calendly booking, savings
 * widget submit) should call `suppressExitIntent()` so the prospect doesn't
 * get a "wait, before you go!" modal a few seconds after they already said
 * yes. Same sessionStorage key the modal itself reads on mount.
 */
export const EXIT_INTENT_STORAGE_KEY = 'shipmaster_exit_intent_v1';

export function suppressExitIntent() {
  try {
    sessionStorage.setItem(EXIT_INTENT_STORAGE_KEY, '1');
  } catch {
    /* storage blocked — accept the regression */
  }
}
